import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Obtener el token de acceso
    const token = localStorage.getItem('token');

    // Si hay token, agregarlo al encabezado Authorization
    let modifiedRequest = req;
    if (token) {
      modifiedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        // El refresh token no es valido o ha expirado
        if(error.status === 423){
          // Borrar toda la información del localStorage y redirigir al login
          localStorage.clear();
          this.router.navigate(['/login']);
          return EMPTY;
        }

        // Si el error es 401 (no autorizado) y el token ha expirado
        if (error.status === 401 && this.authService.isTokenExpired()) {
          return this.handleAuthError(req, next); // Llamamos a la función para refrescar el token
        }
        return throwError(() => error); // Si no es un error relacionado con autenticación, lo lanzamos
      })
    );
  }

  private handleAuthError(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Llamar al servicio de Auth para refrescar el token
    return this.authService.refreshToken().pipe(
      switchMap((newToken) => {
        if (newToken) {
          // Si obtuvimos un nuevo token, volver a intentar la solicitud original
          const clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`
            }
          });
          return next.handle(clonedRequest);  // Reintentar la solicitud con el nuevo token
        }
        // Si no obtuvimos un nuevo token, redirigir al login
        this.router.navigate(['/login']);
        return EMPTY;  // Usar EMPTY en lugar de of(null)
      }),
      catchError((error) => {
        // Si no se pudo refrescar el token, redirigir a login
        this.router.navigate(['/login']);
        return throwError(() => error);
      })
    );
  }
}
